import type { ActivityType } from "@/core/types";

export const activityListKeys = {
  base: ["activities"] as const,
  byType: (type: ActivityType) => [...activityListKeys.base, type] as const,
};
